import React, { Component } from "react";
import { Tag, Select, Radio, Icon } from "antd";
import PropTypes from "prop-types";

var _ = require("lodash");
const Option = Select.Option;
const RadioGroup = Radio.Group;

class TagOptionFilterInput extends Component {
  onChange = ele => {
    this.props.onFilterSet({ selectedOptions: ele });
  };

  opChange = op => {
    this.props.onFilterSet({ operator: op.target.value });
  };

  onFilterOption = (input, option) => {
    // console.log({ input, option });
    if (
      option &&
      option.props &&
      option.props.children &&
      Array.isArray(option.props.children) &&
      option.props.children.length &&
      option.props.children[0] &&
      option.props.children[0].toLowerCase().indexOf(input.toLowerCase()) >= 0
    ) {
      // console.log("case 1.....", option.props.children[0]);
      return true;
    }
    if (
      option &&
      option.props &&
      option.props.children &&
      typeof option.props.children == "string" &&
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    ) {
      // console.log("case 2.....", option.props.children);
      return true;
    }
    // console.log("not found......");
    return false;
  };

  render() {
    const radioStyle = {
      display: "block",
      height: "30px",
      lineHeight: "30px"
    };
    let _that = this;
    return (
      <span>
        {/* <RadioGroup onChange={this.opChange} defaultValue="match-all">
          <Radio style={radioStyle} value="in">
            match all
          </Radio>
          <Radio style={radioStyle} value="contains">
            match any
          </Radio>
        </RadioGroup> */}
        <Select
          mode="multiple"
          style={{ width: "100%" }}
          placeholder="Please select"
          defaultValue={this.props.filterOptions.selectedOptions}
          onChange={this.onChange}
          showSearch
          optionFilterProp="children"
          filterOption={this.onFilterOption}
          // filterOption={(input, option) =>
          //   option &&
          //   option.props &&
          //   option.props.children &&
          //   option.props.children.hasOwnProperty("toLowerCase") &&
          //   option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
          //   0
          // }
        >
          {_.map(this.props.filterOptions.options, function(val) {
            return (
              <Option key={val.id} value={val.id.toString()}>
                {val.name}{" "}
                {_that.props.showLinked &&
                (val.testCaseCount === undefined ||
                  (_that.props.projectId &&
                    val.project &&
                    val.project != _that.props.projectId)) ? (
                  <Icon type="link" />
                ) : null}
              </Option>
            );
          })}
        </Select>
      </span>
    );
  }
}

export default TagOptionFilterInput;
